import Checkbox from "@material-ui/core/Checkbox";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import withStyles from "@material-ui/core/styles/withStyles";
import TableRow from "@material-ui/core/TableRow";
import MoreVertIcon from "@material-ui/icons/MoreVertOutlined";
import { observer } from "mobx-react";
import React from "react";
import { DraggableComponent } from "lego-gui-lib/lib/components/DragAndDrop/DragAndDrop";
import {
  Cell,
  Column,
  createHashFromMap,
  DataTableProps,
  styles
} from "lego-gui-lib";
import { Form, Field, FieldProps } from "react-final-form";

export interface DataTableRowProps extends DataTableProps, DraggableComponent {
  row: any;
}

// copied from gui-lib because importing leads to an application crash on production build
// possible cause : transpilation of "react-final-form" during lib building

export const DraggableDataTableRow = withStyles(styles)(
  observer(
    React.forwardRef((props: DataTableRowProps, ref) => {
      const {
        row,
        columns,
        classes,
        rowButtons,
        selected,
        inlineRowButtons,
        draggableProps,
        isDragged
      } = props;

      const onChange = (): void => {
        props.toggleSelect(true, row);
      };

      const onSubmit = (): void => {
        return;
      };

      const prepareComponentProps = (column: Column) => {
        let val = "";
        const columnProps: any = column.type.props;
        if (columnProps) {
          const ids: any = {};
          props.columns.primaryKey.forEach((key: string) => {
            ids[key] = row[key];
          });
          columnProps.updateRows = props.updateRows;
          columnProps.keyvalue = ids;
          columnProps.columnname = column.name;
          columnProps.columntitle = column.title || column.name;
        }
        if (row[column.name] != null && row[column.name] != undefined) {
          val = row[column.name];
        }
        return {
          name: column.name,
          meta: {},
          key: column.name,
          input: {
            value: val
          },
          component: column.type.PresentationComponent,
          ...column.type.props
        } as FieldProps<any, any>;
      };

      const getFinalForm = (props: any, cellClass?: string) => {
        return (
          <Form onSubmit={onSubmit}>
            {() => {
              return (
                <>
                  {props.checkboxes ? (
                    <></>
                  ) : (
                    // @ts-ignore
                    <Cell
                      padding="checkbox"
                      className={classes.checkboxCell}
                      key={"__data_table_row_checkbox"}
                    >
                      <Checkbox
                        checked={selected.indexOf(row) !== -1}
                        onChange={onChange}
                        color="primary"
                      />
                    </Cell>
                  )}
                  {columns.mapFields(
                    column => {
                      const presentationProps = prepareComponentProps(column);
                      return (
                        // @ts-ignore
                        <Cell
                          key={column.name}
                          className={cellClass || classes.cell}
                        >
                          <Field {...presentationProps} />
                        </Cell>
                      );
                    },
                    { data: row }
                  )}
                  {rowButtons && (
                    // @ts-ignore
                    <Cell
                      className={
                        inlineRowButtons
                          ? classes.buttonsColumn
                          : classes.buttonColumn
                      }
                      key={"__data_table_row_buttons"}
                    >
                      <RowMenu {...props} />
                    </Cell>
                  )}
                </>
              );
            }}
          </Form>
        );
      };

      return (
        <TableRow
          classes={{ selected: classes.row }}
          className={isDragged ? classes.dragging : undefined}
          ref={ref}
          {...draggableProps}
        >
          {getFinalForm(props, isDragged ? classes.draggedCell : undefined)}
        </TableRow>
      );
    })
  )
);

export class RowMenu extends React.Component<DataTableRowProps> {
  public state = {
    anchorEl: null
  };

  public handle = (event: any) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  public handleClose = () => {
    this.setState({ anchorEl: null });
  };

  public render() {
    const { inlineRowButtons } = this.props;

    return (
      <>{inlineRowButtons ? this.inlineButtons() : this.dropDownButtons()}</>
    );
  }

  private inlineButtons() {
    const { row, rowButtons, classes } = this.props;
    const key = createHashFromMap(this.props.columns.Named);
    const buttons =
      (rowButtons && (rowButtons(row, key, this.close) as any)) || [];

    return buttons.map((button: any, index: number) => (
      <div key={index + "rb"} className={classes.inlineButton}>
        {button}
      </div>
    ));
  }

  private dropDownButtons() {
    const { anchorEl } = this.state;
    const { row, rowButtons } = this.props;
    const open = Boolean(anchorEl);
    const key = createHashFromMap(this.props.columns.Named);
    const buttons = rowButtons && (rowButtons(row, key, this.close) as any);
    const isEmptyArray = Array.isArray(buttons) && !buttons.length;

    return !isEmptyArray ? (
      <>
        <IconButton
          aria-label="More"
          aria-haspopup="true"
          onClick={this.handle}
        >
          <MoreVertIcon />
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={this.handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left"
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left"
          }}
          getContentAnchorEl={null}
        >
          {buttons}
        </Menu>
      </>
    ) : null;
  }

  public close = () => {
    this.handleClose();
  };
}
